import React from "react";
import { Check, X, HelpCircle } from "lucide-react";

// value: "available" | "unavailable" | "nc"
export const DocStatus = ({ value, label }) => {
  const v = value || "nc";
  const cfg = {
    available: { icon: Check, bg: "bg-emerald-50", color: "text-emerald-700", text: "Disponible" },
    unavailable: { icon: X, bg: "bg-red-50", color: "text-red-700", text: "Indisponible" },
    nc: { icon: HelpCircle, bg: "bg-slate-100", color: "text-slate-600", text: "Non communiqué" },
  }[v];
  const Icon = cfg.icon;
  return (
    <div className={`flex items-center gap-2 rounded-lg px-3 py-2 ${cfg.bg}`}>
      <Icon size={14} className={cfg.color} />
      <div className="flex-1 text-sm">
        <div className="font-semibold text-[#111827]">{label}</div>
        <div className={`text-xs ${cfg.color}`}>{v === "nc" ? "NC" : cfg.text}</div>
      </div>
    </div>
  );
};

export const DocBadge = ({ value, label }) => {
  if (value !== "available") return null;
  return (
    <span className="text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded bg-emerald-50 text-emerald-700 inline-flex items-center gap-1">
      <Check size={10} /> {label}
    </span>
  );
};
